import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../../environments/environment';
import { ChatMessage } from '../../models/assistant/chat-message';
import { ChatRequest } from '../../models/assistant/chat-request';
import { ChatResponse } from '../../models/assistant/chat-response';
import { ChatSession } from '../../models/assistant/chat-session';
import { PatchSessionRequest } from '../../models/assistant/patch-session-request';
import { HEADER_AVOID_ERROR_HANDLING } from '../base/headers';

@Injectable()
export class AssistantApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    // The frontend always talks to borneo_api (proxy /v1/assistant/*), never the
    // borneo-assistant microservice directly. Same JWT, injected by JwtInterceptor.
    this.apiUrl = `${ environment.apiUrl }assistant`;
  }

  chat(request: ChatRequest): Observable<ChatResponse> {
    // Avoid the global error toast: chat errors are shown inline as an assistant bubble.
    const headers = { [HEADER_AVOID_ERROR_HANDLING]: 'true' };
    return this.httpClient.post<ChatResponse>(`${ this.apiUrl }/chat`, request, { headers });
  }

  listConversations(): Observable<ChatSession[]> {
    return this.httpClient.get<ChatSession[]>(`${ this.apiUrl }/conversations`);
  }

  listMessages(conversationHash: string): Observable<ChatMessage[]> {
    return this.httpClient.get<ChatMessage[]>(`${ this.apiUrl }/conversations/${ conversationHash }/messages`);
  }

  patchConversation(conversationHash: string, request: PatchSessionRequest): Observable<ChatSession> {
    return this.httpClient.patch<ChatSession>(`${ this.apiUrl }/conversations/${ conversationHash }`, request);
  }

  deleteConversation(conversationHash: string): Observable<void> {
    return this.httpClient.delete<void>(`${ this.apiUrl }/conversations/${ conversationHash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/assistant-api.service.ts